import { render, staticRenderFns } from "./ExtraFieldItem.vue?vue&type=template&id=d2a33530&"
import script from "./ExtraFieldItem.vue?vue&type=script&lang=js&"
export * from "./ExtraFieldItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports